import { Component } from '@angular/core'
import { NotificationType, PageStyle } from '@ftr/foundation'

@Component({
  selector: 'ftr-courtroom-display',
  templateUrl: './courtroom-display.component.html',
  styleUrls: ['./courtroom-display.component.css'],
  host: {
    class: 'courtroom display page',
  },
})
export class CourtroomDisplayComponent {
  readonly pageStyle = PageStyle.Narrow
  readonly notificationType = NotificationType
}
